import { Subject } from 'rxjs';

export const productGridReloadSubject = new Subject();
